export default __webpack_public_path__ + "static/media/planet-jupiter.b1d0956b.svg";